import api from './api';
import { ActivityLog } from '../types';

export const activityLogApi = {
    getByEntity: (entityType: ActivityLog['entity_type'], entityId: number) =>
        api.get<ActivityLog[]>(`/activity-logs/${entityType}/${entityId}`),

    create: (data: {
        entity_type: ActivityLog['entity_type'];
        entity_id: number;
        action: string;
        description: string;
        metadata?: any;
    }) => api.post('/activity-logs', data),
};
